import Vue from "vue";
import ServiceTipTagWeb from "./ServiceTipTagWeb.vue";
import { query } from "qs";
new Vue({
  el: ".service-tip-tag-container",
  template: `
    <service-tip-tag-web 
      :scene="scene"
      :activity-id="activityId"
      :ticket-good-id="ticketGroupId"
      :ticket-count="ticketCount"
      :order-id="orderId"
      :initTab="initTab"
      :initAnchorRefName="initAnchorRefName"
      :hiddenTabs="hiddenTabs"
    />
  `,
  components: {
    ServiceTipTagWeb,
  },
  data() {
    return {
      activityId: query.activityId,
      scene: query.scene || "ACTIVITY_DETAIL",
      ticketGroupId: query.ticketGroupId,
      ticketCount: query.ticketCount,
      orderId: query.orderId,
      initTab: Number(query.initTab),
      initAnchorRefName: query.tipType ? `tip-info-${query.tipType}` : "",
      hiddenTabs: query.hiddenTabs ? query.hiddenTabs : "",
    };
  },
  beforeMount() {
    console.log(7777, query, this.activityId);
  },
});



// WEBPACK FOOTER //
// ./src/about/serviceTipTagWeb.js